/**
 * Check if the given entity is an institution.
 * Benchmarking Social Impact currently supports institution only.
 *
 * @param {Object} entity
 * @returns {boolean}
 */
export const isInstitutionEntity = (entity) => {
  if (!entity) return false;
  const type = entity.entity_type || entity.type;
  if (!type) return true; // Default entity in overview/benchmarking is institution
  return type.toLowerCase() === "institution";
};

/**
 * Build clean query parameters for Benchmarking Social Impact endpoint.
 *
 * @param {Object} entity
 * @param {Object} [filters]
 * @returns {Object|null}
 */
export const buildBenchmarkingSocialImpactParams = (entity, filters) => {
  if (!entity?.id || !isInstitutionEntity(entity)) {
    return null;
  }

  const rawSubject = filters?.subjectArea;
  let subjectAreaParam;

  if (Array.isArray(rawSubject)) {
    if (rawSubject.length > 0 && rawSubject[0]) {
      subjectAreaParam = [String(rawSubject[0]).trim()];
    }
  } else if (typeof rawSubject === "string" && rawSubject.trim()) {
    subjectAreaParam = [rawSubject.trim()];
  }

  const params = {
    entity_id: entity.id,
    year_range: filters?.yearRange || "all",
  };

  if (subjectAreaParam && subjectAreaParam.length > 0 && subjectAreaParam[0]) {
    params.subject_area = subjectAreaParam;
  }

  return params;
};
